import PropTypes from 'prop-types';
import React from 'react';
import { Box, Collapse, List, ListItem, Typography } from '@mui/material';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { categoryHeaderSx, categoryLabelSx } from './styles';

/**
 * Sección colapsable del sidebar: encabezado clickeable + lista de items.
 * El estado de abierto/cerrado lo controla el padre (open + onToggle) para que
 * varias secciones compartan un mismo registro.
 */
function CategorySection({ label, open, onToggle, children }) {
  return (
    <Box sx={{ py: 0.5 }}>
      <ListItem button onClick={onToggle} aria-expanded={open} sx={categoryHeaderSx}>
        <Typography variant="overline" sx={categoryLabelSx}>
          {label}
        </Typography>
        {open ? (
          <ExpandLessIcon fontSize="small" sx={{ color: 'text.secondary' }} />
        ) : (
          <ExpandMoreIcon fontSize="small" sx={{ color: 'text.secondary' }} />
        )}
      </ListItem>
      <Collapse in={open} timeout="auto" unmountOnExit>
        <List disablePadding>{children}</List>
      </Collapse>
    </Box>
  );
}

CategorySection.propTypes = {
  label: PropTypes.string.isRequired,
  open: PropTypes.bool.isRequired,
  onToggle: PropTypes.func.isRequired,
  children: PropTypes.node,
};

export default CategorySection;
